module.exports = __webpack_public_path__ + "static/media/Rinat.0b35e201.jpg";